var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _path2, _rect11, _rect12, _rect13, _rect14, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormNested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 105.83 79.375",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.063,
    y: 4.9541,
    width: 23.683,
    height: 3.7042,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#0058ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.729,
    y: 2.0242,
    width: 48.179,
    height: 75.71,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#99bcff",
    strokeMiterlimit: 10,
    strokeWidth: 0.34414
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1.3007 0 0 1.3007 25.271 -3.301)",
    x: 31.817,
    y: 54.894,
    width: 19.012,
    height: 5.5571,
    rx: 0.40684,
    ry: 0.40684,
    fill: "#0058ff"
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.024,
    y: 39.879,
    width: 45.898,
    height: 27.033,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ffd199",
    strokeWidth: 0.26458
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58.047,
    y: 61.388,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ff8c00",
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 59.32695,
    y: 64.755516,
    fill: "#ffd199",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57.99,
    y: 57.917,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ff8c00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.047,
    y: 51.064,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#ff8c00",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.99,
    y: 47.455,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ff8c00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61.367 42.528-0.50106-0.12211-0.88454 0.56748v3.4461h-0.79449v-0.56344c0.02473 0.0055 0.05044 0.0083 0.07679 0.0083 0.19389 0 0.35093-0.15697 0.35093-0.35077 0-0.10787-0.04868-0.20443-0.12534-0.26879 0.07662-0.06436 0.12534-0.16092 0.12534-0.26879 0-0.16496-0.1138-0.30321-0.26722-0.3408-0.02448-0.13258-0.14066-0.23302-0.28023-0.23302-0.13966 0-0.25593 0.10044-0.28023 0.23293-0.15342 0.03758-0.26738 0.17584-0.26738 0.34089 0 0.10787 0.04868 0.20443 0.1254 0.26879-0.07671 0.06436-0.1254 0.16092-0.1254 0.26879 0 0.1938 0.15712 0.35077 0.35093 0.35077 0.02635 0 0.05199-0.0028 0.07671-0.0083v0.56344h-0.39691v0.2397h6.3822v-0.2397h-0.39701v-0.56351c0.02474 0.0055 0.05043 0.0084 0.07681 0.0084 0.1939 0 0.35092-0.15697 0.35092-0.35077 0-0.10787-0.04857-0.20443-0.12523-0.26878 0.07658-0.06436 0.12523-0.16092 0.12523-0.26879 0-0.16496-0.11379-0.30321-0.2672-0.3408-0.02457-0.13258-0.14067-0.23302-0.28023-0.23302-0.13967 0-0.25593 0.10044-0.28024 0.23293-0.15332 0.03758-0.26737 0.17584-0.26737 0.34089 0 0.10787 0.04886 0.20443 0.12548 0.26879-0.07667 0.06436-0.12548 0.16092-0.12548 0.26878 0 0.1938 0.15712 0.35077 0.35092 0.35077 0.02638 0 0.05198-0.0028 0.07664-0.0083v0.56345h-0.7943v-5.3384l-0.9447-0.23014-1.1898 0.76327v0.91372zm-0.51655 3.8915v-3.7193l-0.62938 0.40366v3.3156h0.62938zm1.7549 0v-5.3106l-0.0053-0.0013-0.99343 0.63729v4.6747h0.99866z",
    fill: "#ff8c00",
    fillRule: "evenodd",
    strokeWidth: 0.0016019
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58.047,
    y: 33.125,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#0058ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 59.326954,
    y: 36.492493,
    fill: "#99bcff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeMiterlimit: 10,
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----"), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.99,
    y: 29.654,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#0058ff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.047,
    y: 22.801,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#0058ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57.99,
    y: 19.192,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#0058ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.512 17.642c-0.1759-0.03263-0.31707-0.16038-0.3707-0.33544-0.0178-0.0581-0.02377-0.1437-0.01396-0.20005 0.01689-0.09701 0.16682-0.59151 0.3112-1.0266 0.02303-0.06937 0.0528-0.12015 0.10112-0.17233 0.07496-0.08097 0.11464-0.10156 0.50166-0.26029 0.12783-0.05243 0.28398-0.11683 0.34702-0.1431 0.18395-0.07666 0.40624-0.16136 0.6413-0.2443l0.07811-0.02755 0.01703 0.0589c0.07483 0.25889 0.5197 1.5654 0.5409 1.5885 0.0032 0.0036 0.0055-0.0045 0.0055-0.01936-6e-5 -0.01401 0.01181-0.28159 0.02638-0.59461l0.02646-0.5691-0.10995-0.21826c-0.04434-0.07365-0.13591-0.19775-0.11787-0.21261 0.01113-0.0092 0.0312 0.0086 0.06046 0.02361 0.12451 0.06232 0.26613 0.11971 0.4406 0.12649 0.19146 0.0074 0.34594-0.05248 0.5078-0.1258 0.03315-0.01552 0.06885-0.04239 0.08231-0.0272 0.01812 0.02045-0.13013 0.20564-0.13235 0.21006l-0.11267 0.22289 0.02739 0.59356c0.01508 0.32645 0.0294 0.59146 0.03184 0.58888 0.01599-0.01692 0.47574-1.369 0.54297-1.5969l0.01456-0.04932 0.21626 0.07905c0.25453 0.09303 0.28093 0.10323 0.51147 0.19747 0.73148 0.29895 0.73962 0.30273 0.81992 0.37937 0.04096 0.03907 0.08785 0.10493 0.10422 0.14639 0.0055 0.0142 0.03057 0.08908 0.05547 0.16638 0.16446 0.51043 0.25889 0.82645 0.27175 0.90934 0.0241 0.15536-0.0457 0.33147-0.17181 0.4335-0.04376 0.03543-0.1233 0.07649-0.18058 0.09331-0.03666 0.01075-0.17296 0.0114-2.5337 0.01242-2.022 8.48e-4 -2.5035-5.27e-4 -2.5402-0.0073zm2.4334-2.6402c-0.29862-0.06501-0.58668-0.26163-0.79654-0.54363-0.11209-0.15067-0.225-0.37323-0.28504-0.56184-0.01421-0.04458-0.01554-0.04642-0.03137-0.04206-0.03018 0.0084-0.08086 0.0035-0.10776-0.01018-0.10224-0.05216-0.17276-0.21814-0.20613-0.48518-0.02038-0.16295-0.0055-0.24513 0.05391-0.29738 0.03767-0.03317 0.0782-0.04491 0.15494-0.04491h0.06085l-0.0045-0.1049c-0.01599-0.3706-0.01442-0.4639 0.0098-0.58868 0.10178-0.5249 0.53522-0.92556 1.0688-0.98796 0.38327-0.04482 0.72523 0.05511 1.0085 0.29478 0.18552 0.15694 0.33501 0.40838 0.39078 0.65732 0.02898 0.12936 0.03334 0.20868 0.02457 0.44844-0.0043 0.1173-0.0078 0.22851-0.0077 0.24713l1.39e-4 0.03389h0.0606c0.09994 0 0.15146 0.02448 0.18631 0.08851 0.03414 0.06273 0.03619 0.15034 0.0077 0.33108-0.04417 0.28011-0.15223 0.44218-0.28186 0.42275-0.01516-0.0023-0.03019-0.0041-0.03339-4e-3 -0.0032 7.9e-5 -0.01653 0.03153-0.02961 0.06989-0.13254 0.3886-0.35985 0.7008-0.65205 0.89544-0.07515 0.05007-0.20249 0.11392-0.28403 0.14247-0.13279 0.04645-0.22116 0.0577-0.30685 0.03905z",
    fill: "#0058ff",
    strokeWidth: 0.0070192
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.175)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.186,
    y: 10.729,
    width: 45.898,
    height: 27.033,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ffd199",
    strokeWidth: 0.26458
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 6.2087,
    y: 32.237,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stroke: "#ffba66",
    strokeWidth: 0.3346
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 7.4888206,
    y: 35.605099,
    fill: "#ffe8cc",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.0972px",
    letterSpacing: ".34414px",
    strokeWidth: 0.34104,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, "--/--/----")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1519,
    y: 28.767,
    width: 15.875,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffba66"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.2087,
    y: 21.913,
    width: 43.715,
    height: 4.4833,
    rx: 0.52917,
    ry: 0.52917,
    fill: "none",
    stopColor: "#000000",
    stroke: "#ffba66",
    strokeMiterlimit: 10,
    strokeWidth: 0.3346,
    style: {
      InkscapeStroke: "none",
      fontVariationSettings: "normal"
    }
  }), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1519,
    y: 18.305,
    width: 11.906,
    height: 2.6458,
    rx: 0.52917,
    ry: 0.52917,
    fill: "#ffba66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.529 13.378-0.50106-0.12211-0.88454 0.56748v3.4461h-0.79449v-0.56344c0.02473 0.0055 0.05044 0.0083 0.07679 0.0083 0.19389 0 0.35093-0.15697 0.35093-0.35077 0-0.10787-0.04868-0.20443-0.12534-0.26879 0.07662-0.06436 0.12534-0.16092 0.12534-0.26879 0-0.16496-0.1138-0.30321-0.26722-0.3408-0.02448-0.13258-0.14066-0.23302-0.28023-0.23302-0.13966 0-0.25593 0.10044-0.28023 0.23293-0.15342 0.03758-0.26738 0.17584-0.26738 0.34089 0 0.10787 0.04868 0.20443 0.1254 0.26879-0.07671 0.06436-0.1254 0.16092-0.1254 0.26879 0 0.1938 0.15712 0.35077 0.35093 0.35077 0.02635 0 0.05199-0.0028 0.07671-0.0083v0.56344h-0.39691v0.2397h6.3822v-0.2397h-0.39701v-0.56351c0.02474 0.0055 0.05043 0.0084 0.07681 0.0084 0.1939 0 0.35092-0.15697 0.35092-0.35077 0-0.10787-0.04857-0.20443-0.12523-0.26878 0.07658-0.06436 0.12523-0.16092 0.12523-0.26879 0-0.16496-0.11379-0.30321-0.2672-0.3408-0.02457-0.13258-0.14067-0.23302-0.28023-0.23302-0.13967 0-0.25593 0.10044-0.28024 0.23293-0.15332 0.03758-0.26737 0.17584-0.26737 0.34089 0 0.10787 0.04886 0.20443 0.12548 0.26879-0.07667 0.06436-0.12548 0.16092-0.12548 0.26878 0 0.1938 0.15713 0.35077 0.35092 0.35077 0.02638 0 0.05198-0.0028 0.07664-0.0083v0.56345h-0.7943v-5.3384l-0.9447-0.23014-1.1898 0.76327v0.91372zm-0.51655 3.8915v-3.7193l-0.62938 0.40366v3.3156h0.62938zm1.7549 0v-5.3106l-0.0053-0.0013-0.99343 0.63729v4.6747h0.99866z",
    fill: "#ffba66",
    fillRule: "evenodd",
    strokeWidth: 0.0016019
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m30.582 42.312c-3.8001 5.5176-2.4283 11.436 2.166 14.945 4.5943 3.5094 12.359 4.6544 21.334 0.9043l-0.20312-0.48828c-8.8397 3.6935-16.401 2.5323-20.811-0.83594-4.4095-3.3682-5.7186-8.8991-2.0508-14.225z",
    color: "#000000",
    fill: "#3d4193",
    strokeMiterlimit: 10,
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.125 56.77-0.19922 0.48828 1.832 0.75195-0.75391 1.832 0.49024 0.20117 0.95312-2.3203z",
    color: "#000000",
    fill: "#3d4193",
    style: {
      InkscapeStroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormNested);
export default __webpack_public_path__ + "static/media/form-nested.27ba446aff428340c0768a9894d4e417.svg";
export { ForwardRef as ReactComponent };